import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useDebouncedState } from '@mantine/hooks';
import { toast } from 'react-toastify';
import { RECORDS_PER_PAGE } from '../../config';
import { useState } from 'react';
import { handleLock, LogoutCheck } from '../utils';
import { buildAxiosInstance } from '../axiosInstance';
import { useMsal } from '@azure/msal-react';
import { useRef } from 'react';
import axios from 'axios';


const fetchinvoicesList = async ( Args, dispatch, signal,instance) => {
	await handleLock(dispatch, 'last_doc_open',instance)
	try {
		const TOAST_ID = 'global_invoice_list'
		const axiosInstance = buildAxiosInstance(TOAST_ID)
		let config = {
			params: {...Args, limit: localStorage.getItem("page_count")},
			signal: signal,
		};
		const responseData = await axiosInstance.get('/global_invoice_list',config)
		return responseData
	} catch (error) {
		LogoutCheck(error, dispatch,instance)	
		
	};
};

export const useInvoiceslistPagewise = () => {
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'global_invoice_list'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/global_invoice_list`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
	});
};


export const useDeleteInvoice = () => {
	const queryClient = useQueryClient() 
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'delete_invoice_entities'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.delete(`/delete_invoice_entities`,{data : JSON.stringify(body)});
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		  },
	});
};


const fetchClientList = async (Args, dispatch, signal,instance) => {

	try {
		const TOAST_ID = 'vendor_names_list'
		const axiosInstance = buildAxiosInstance(TOAST_ID)
		let config = {
			params: {...Args, limit: localStorage.getItem("page_count")},
			signal: signal,
		};
		const responseData = await axiosInstance.get('/vendor_names_list',config)
		return responseData
	} catch (error) {
		LogoutCheck(error, dispatch,instance)	
		
	};
};

export const useVendorNames = (client_id) => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	const [Args, setArgs] = useDebouncedState(
		{
			search: '',
			client_id: client_id,
			page:1
		},
		1000
	);
	const hook = useQuery({
		queryKey: ['vendor_names', Args],
		queryFn: async ({ signal }) => fetchClientList(Args, dispatch, signal,instance),
		retry: false,
	});
	return {
		hook: hook,
		Args: Args,
		setArgs: setArgs,
	};
};


export const useGetFilter = () => {
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'get_filter_value'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/get_filter_value`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		// onSuccess: () => {
		// 	queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		//   },

	});
};

export const useMinMaxDate = () => {
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'get_min_max'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/get_min_max`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		// onSuccess: () => {
		// 	queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		//   },

	});
};



export const useCategoryNameById = (cat_id) => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['cat_name', cat_id],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'get_category_by_id'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					params: {id:cat_id},
					signal:signal
				};
				const responseData = await axiosInstance.get('/get_category_by_id',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};

export const useBulkMarkComplete = () => {
	const { instance } = useMsal();
	let dispatch = useDispatch();
	//const Data = useSelector(state => state.auth)
	return useMutation({
		retry: 1,
		mutationFn:async (body)=> {
			try {
				const TOAST_ID = 'mark_complete_bulk'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.put(`/mark_complete`, JSON.stringify(body));
				toast.success(responseData.message)
				return responseData
			} catch (error) {

				LogoutCheck(error, dispatch,instance)
			}
		}
	});
};

export const useGlobalSearch = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'global_search';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/global_search`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};

export const useInvoiceParentFilters = () => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['invoice_filters'],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'get_invoice_filter'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					signal:signal
				};
				const responseData = await axiosInstance.get('/invoice_search_parent_filters',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};

export const useInvoiceChildFilters = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'invoice_search_child_filters';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/invoice_search_child_filters`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};

export const useContractFilters = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'contracts_by_parent_filter';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/contracts_by_parent_filter`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};


export const useFieldsFilters = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'fields_list';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/fields_list`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};


export const useSearchInvoices = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'invoice_search_by_filter';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/invoice_search_by_filter`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};



export const useContractParentFilters = () => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['contract_filters'],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'get_contract_filter'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					signal:signal
				};
				const responseData = await axiosInstance.get('/contract_search_parent_filters',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};

export const useContractChildFilters = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'contract_search_child_filters';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/contract_search_child_filters`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};

export const useSearchContract = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    const cancelTokenRef = useRef(null); // Store cancel token

    return useMutation({
        retry: false,
        mutationFn: async (body) => {
            const TOAST_ID = 'contract_search_by_filter';

            // Cancel previous request if it exists
            if (cancelTokenRef.current) {
                cancelTokenRef.current.abort(); // AbortController method
            }

            // Create new AbortController
            const controller = new AbortController();
            cancelTokenRef.current = controller;

            try {
                const axiosInstance = buildAxiosInstance(TOAST_ID);
                const responseData = await axiosInstance.get(`/contract_search_by_filter`, {
                    params: body,
                    signal: controller.signal,
                });

                const message = responseData?.message;
                if (message) {
                    toast.success(message, { toastId: TOAST_ID });
                }

                return responseData;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    LogoutCheck(error, dispatch, instance);
                    throw error;
                }
            }
        },
    });
};
